import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion'
import { motion } from 'framer-motion'
import Link from '../Link'
import { CreateLocalLink } from '../../utils/relative-url'
import { GlobalDispatchContext } from '../../contexts/GlobalContextProvider'
import Chevron from '../../assets/chevron.svg'

const MenuWrap = styled((props) => <motion.nav {...props} />)`
  ${tw`mt-2 mb-10 tracking-wide`}

  .icon {
    transform: rotate(-180deg);
    ${tw`transition-transform duration-300 ease-in-out`}
  }

  .accordionIsOpen {
    .icon {
      transform: rotate(0deg);
    }
  }
`

const AccordionTitleWrap = styled.div`
  ${tw`flex justify-between items-center`}
`

const AccordionTitleIcon = styled.div`
  svg {
    fill: #505050;
  }
`

export default function Menu(props) {
  const dispatch = useContext(GlobalDispatchContext)
  const { menu } = props
  return (
    <MenuWrap initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, delay: 0.15 }}>
      <Accordion allowZeroExpanded>
        {menu?.map((item) => (
          <div key={item.key} className="px-10">
            {item.children.length === 0 ? (
              <Link
                to={CreateLocalLink(item.url)}
                className="block py-4 text-lg"
                activeClassName="menuactive"
                partiallyActive
                onClick={() => {
                  dispatch({ type: 'TOGGLE_DRAWER_MENU' })
                }}
              >
                {item.title}
              </Link>
            ) : (
              <AccordionItem activeClassName="accordionIsOpen">
                <AccordionItemHeading>
                  <AccordionItemButton className="focus:outline-none">
                    <AccordionTitleWrap>
                      <Link
                        to={CreateLocalLink(item.url)}
                        className="noclick block py-2 text-lg"
                        activeClassName="menuactive"
                        partiallyActive
                        onClick={() => {
                          dispatch({ type: 'TOGGLE_DRAWER_MENU' })
                        }}
                      >
                        {item.title}
                      </Link>
                      <AccordionTitleIcon className="icon">
                        <Chevron />
                      </AccordionTitleIcon>
                    </AccordionTitleWrap>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel className="pb-4 mb-4 border-b border-colekt-gray">
                  {item?.children?.map((childItem) => (
                    <Link
                      to={CreateLocalLink(childItem.url)}
                      className="block py-2 text-sm"
                      activeClassName="menuactive"
                      onClick={() => {
                        dispatch({ type: 'TOGGLE_DRAWER_MENU' })
                      }}
                      key={childItem.key}
                    >
                      {childItem.title}
                    </Link>
                  ))}
                </AccordionItemPanel>
              </AccordionItem>
            )}
          </div>
        ))}
      </Accordion>
    </MenuWrap>
  )
}

Menu.propTypes = {
  menu: PropTypes.array.isRequired,
}
